export const publicationList = {
    securedAIAgent: [
        {
            title: "Real-Time Optimal Power Flow with Linguistic Stipulations: Integrating GPT-Agent and Deep Reinforcement Learning",
            source: "IEEE Transactions on Power Systems, early access",
            year: "2024",
            citationCount: "5",
            extraInfo: "Homepage Popular Article in IEEE TWPRS"
        },
        {
            title: "Data-Driven Load Frequency Control for Stochastic Power Systems: A Deep Reinforcement Learning Method With Continuous Action Search",
            source: "IEEE Transactions on Power Systems, vol. 34, no. 2, pp. 1653-1656",
            year: "March 2019",
            citationCount: "329",
            extraInfo: "Web of Science ESI highly cited paper, Homepage Popular Article in IEEE TWPRS during 2019-2022"
        },
        {
            title: "A Multi-Agent Deep Reinforcement Learning Method for Cooperative Load Frequency Control of Multi-Area Power Systems",
            source: "IEEE Transactions on Power Systems",
            year: "2020",
            citationCount: "247",
            extraInfo: "Homepage Popular Article in IEEE TWPRS during 2021-Now"
        },
        {
            title: "Real-Time Optimal Power Flow: A Lagrangian based Deep Reinforcement Learning Approach",
            source: "IEEE Transactions on Power Systems",
            year: "2020",
            citationCount: "154",
        },
        {
            title: "A Hybrid Data-driven Method for Fast Solution of Security-Constrained Optimal Power Flow",
            source: "IEEE Transactions on Power Systems",
            year: "2022",
            citationCount: "34",
        },
        {
            title: "Data-driven Learning-based Economic Control of Battery Energy Storage System Considering Battery Degradation",
            source: "IET Generation Transmission & Distribution",
            year: "2020",
            citationCount: "19",
        },
        {
            title: "Data-driven Economic Control of Battery Energy Storage System considering Battery Degradation",
            source: "presented at 9th ICPES",
            year: "2019",
            citationCount: "8",
        },
        {
            title: "A Multi-Agent Deep Reinforcement Learning Based Multi-Timescale Voltage Control for Distribution System",
            source: "5th IEEE Conference on Energy Internet and Energy System Integration",
            year: "2021",
            citationCount: "3",
        },
    ],
    advancedDataAnalytics: [
        {
            title: "Data-driven robust planning of electric vehicle charging infrastructure for urban residential car parks",
            source: "IET Generation, Transmission & Distribution",
            year: "2021",
            citationCount: "12",
        },
        {
            title: "Topology Optimization of Power Systems Combining Deep Reinforcement Learning and Domain Knowledge",
            source: "Automation of Electric Power Systems",
            year: "2021",
            citationCount: "4+",
        },
        {
            title: "Centrality-based Solar PV Placement Considering SAIDI under Incomplete Network Information",
            source: "2023 IEEE International Conference on Energy Technologies for Future Grids (ETFG)",
            year: "2023",
            citationCount: "0",
        },
        {
            title: "Regional-Privacy-Preserving Operation of Networked Microgrids: Edge-Cloud Cooperative Learning with Differentiated Policies",
            source: "Applied Energy",
            year: "2024",
            citationCount: "0",
        },
        {
            title: "Physical model-assisted deep reinforcement learning for energy management optimization of industrial electric-hydrogen coupling system with hybrid energy storage",
            source: "Journal of Energy Storage",
            year: "2024",
            citationCount: "0",
        },
    ],
    cyberSecurity: [
        {
            title: "A Dimensional Augmentation-Based Data-Driven Method for Detecting False Data Injection in Smart Meters",
            source: "IEEE Transactions on Smart Grid",
            year: "Jan. 2024",
            citationCount: "1",
        },
        {
            title: "Vulnerability Assessment of Deep Reinforcement Learning Models for Power System Topology Optimization",
            source: "IEEE Transactions on Smart Grid",
            year: "2021",
            citationCount: "37",
        },
        {
            title: "A Hybrid Monotonic Neural Network Approach for Multi-Area Power System Load Frequency Control against FGSM Attack",
            source: "IEEE Transactions on Circuits and Systems II: Express Briefs",
            year: "2024",
            citationCount: "1",
        },
        {
            title: "Load Frequency Control with Deep Reinforcement Learning under Adversarial Attacks",
            source: "2023 IEEE 18th Conference on Industrial Electronics and Applications (ICIEA)",
            details: "pp. 257-262",
            year: "2023",
            citationCount: "1",
        },
        {
            title: "A Probabilistic Forecasting Method for Residential Load Demand based on Statistical Error Analysis",
            source: "2022 IEEE Power & Energy Society (PES) General Meeting (GM)",
            year: "2022",
            citationCount: "1",
        },
    ]
};

export const intellectualProperties = {
    authorizedPatents: [
        {
            title: "Electric-gas-heat interconnection system risk evaluation method for considering solar thermal CHP plants and electric boiler",
            patentNumber: "CN201711000231.2",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Stack denoising autoencoder-based probabilistic power flow online calculation method",
            patentNumber: "CN201810033776.1",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Method and device for static equivalence of active power distribution network",
            patentNumber: "CN201710418406.5",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Electricity-gas-heat interconnected system abandoned wind/light and electricity-gas-heat load curtailment generalized least optimization model construction method",
            patentNumber: "CN201711000202.6",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Piezoelectric generation device",
            patentNumber: "CN201610292196.5",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Embedded power generation non-skid band based on piezoelectric effect",
            patentNumber: "CN201520196503.0",
            type: "Utility Patent",
            status: "Authorized"
        },
        {
            title: "RBF neural network-based probability power flow online calculation method",
            patentNumber: "CN201810033786.5",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "Piezoelectric electricity generation device with wide resonance frequency band",
            patentNumber: "CN201610294467.0",
            type: "Invention Patent",
            status: "Authorized"
        },
        {
            title: "On-line calculation method of probabilistic power flow based on BP neural network",
            patentNumber: "CN201810033758.3",
            type: "Invention Patent",
            status: "Authorized"
        },
    ],
    publishedPatents: [
        {
            title: "System and method for second-order cue word of large language model for digital human intellectualization",
            patentNumber: "CN116881415 (A)",
            status: "Published, pending authorization"
        },
        {
            title: "A System and Method for Assets Health Evaluation and Management based on Failure Probability and Condition Monitoring",
            patentNumber: "NTU Ref: 2023-241-01-PCT",
            status: "Published, pending authorization"
        }
    ],
    technicalDisclosures: [
        {
            title: "Data-driven method for adaptive frequency control based on deep reinforcement learning in continuous action domain",
            disclosureNumber: "TD/2018-291"
        },
        {
            title: "Temporal-Spatial Modelling For Electric Vehicle Charging Behavior",
            disclosureNumber: "TD/2020-436"
        },
        {
            title: "Optimal Planning Of Electric Vehicle Charging Facilities In Residential Car Park",
            disclosureNumber: "TD/2020-437"
        },
        {
            title: "Probabilistic Forecasting For Electric Vehicle Update Ratio Based On Deep Learning",
            disclosureNumber: "TD/2020-438"
        },
        {
            title: "A System and Method for Risk valuation, Forecasting and Sensitivity Analysis Using Monotonic Fuzzy Inference System for Infrastructural Asset Management",
            disclosureNumber: "TD/2023-456"
        },
        {
            title: "A System and Method for Assets Health Evaluation and Management Based on Failure Probability and Condition",
            disclosureNumber: "TD/2023-241"
        },
        {
            title: "A New Calculation Method for The Health Index And Remaining Useful Life Of Medium Voltage XLPE Cable Based On The Water Tree",
            disclosureNumber: "2024-205"
        },
        {
            title: "A Holistic Method and Software Tool for Car Park Data Retrieval, Analysis and Privacy-preserving Behaviors Simulation",
            disclosureNumber: "TD/2024-232"
        },
        {
            title: "A System and Method for Car Park Data Retrieval, Analysis And Privacy-Preserving Behaviours Simulation",
            disclosureNumber: "TD/2024-232"
        }
    ]
};

export const workExperience = [
  {
    period: "11/2023-present",
    institution: "Nanyang Technological University, School of Electrical and Electronic Engineering, Singapore.",
    details: "SP Group NTU Presidential Postdoctoral Fellow."
  },
  {
    period: "07/2022-11/2023",
    institution: "Nanyang Technological University, School of Electrical and Electronic Engineering, Singapore.",
    details: "Research Fellow. SP Group - NTU Joint Lab Project."
  },
  {
    period: "12/2021-07/2022",
    institution: "Nanyang Technological University, School of Electrical and Electronic Engineering, Singapore.",
    details: "Student Researcher. NTU and LITE-ON Collaboration Project."
  }
];

export const education = [
  {
    period: "01/2018-07/2022",
    institution: "Nanyang Technological University, School of Electrical and Electronic Engineering, Singapore.",
    details: "Ph.D. CGPA: 4.58/5.00; Thesis: Data-driven Operation and Control for Power Systems with High-level Renewable Energy Resources."
  },
  {
    period: "09/2013-12/2017",
    institution: "Chongqing University, School of Electrical Engineering, Chongqing, China.",
    details: "BSc. Integrated Grades: 92.6/100; Class President of Hongshen Honored Program."
  }
];

export const researchGrants = [
  {
    role: "PI",
    title: "Towards Artificial General Intelligence for Energy Systems Operation: Auto-GPT and Explainable Multi-agent Deep Reinforcement Learning In-the-Loop",
    fundingAgency: "SP Group NTU Presidential Postdoctoral Fellowship",
    grantAmount: "200,000 SGD",
    period: "Start Date - End Date" // Replace with actual dates
  },
  {
    role: "Co-PI",
    title: "Data-Driven Proactive Assets Management based on Adaptive Health Assessments and Robust Decision-Making",
    grantAmount: "1,054,040 SGD",
    period: "Start Date - End Date" // Replace with actual dates
  },
  {
    role: "Collaborator",
    title: "Temporal-Spatial Impact Analysis of Climate Changes on Renewable Energy and Load Demands",
    fundingAgency: "NEA Climate Impact Science Research Programme (CISR)",
    grantAmount: "1,299,220 SGD",
    period: "Start Date - End Date" // Replace with actual dates
  }
];

export const teaching = {
    "Courses as Lecturer": {
        summary: "6 Courses, 17 Mentorships",
        details: [
            {
                title: "EEE Fundamental Courses",
                courses: [
                    {
                        name: "EE2101 Circuit Analysis",
                        description: "Complete group (EE16) for Circuit Analysis, 13 Tutorials and 4 Lab Sessions. Lecturing, instructions for EEE students. (Full course content from basic circuit concepts to three phase circuit analysis).",
                    }
                ]
            },
            {
                title: "Short Courses for AI, Nanyang Business School",
                courses: [
                    {
                        name: "Mastering ChatGPT for Academic Edge",
                        description: "Lecturing, instructions for NBS faculty.",
                    }
                ]
            }
        ]
    },
    "Courses as Teaching Assistant": {
        details: [
            {
                title: "Electrical and Electronic Engineering Courses",
                courses: [
                    {
                        code: "EE2073",
                        name: "EE2073 Introduction to EEE Design and Project",
                        description: "Teaching Assistant. Lab Session, in-hand instructions, and Evaluation.",
                        points: [
                            "Data acquisition system",
                            "Electronic circuit",
                            "Laboratory modules on LabVIEW programming"
                        ]
                    },
                    {
                        code: "EE3010",
                        name: "EE3010 Electrical Devices & Machines",
                        description: "Teaching Assistant. Lecturing, Lab Session, and Evaluation.",
                        points: [
                            "Power systems"
                        ]
                    },
                    {
                        code: "EE1071",
                        name: "EE1071 Introduction to EEE Laboratories",
                        description: "Teaching Assistant. Lab Session and Evaluation.",
                        points: [
                            "Circuits",
                            "AC waveforms",
                            "Circuit-building"
                        ]
                    }
                ]
            },
            {
                title: "Machine Learning and Data Science Courses",
                courses: [
                    {
                        code: "EE0005",
                        name: "EE0005 Data Science and Artificial Intelligence",
                        description: "Teaching Assistant. Lab Session, Lecturing for coding, and Evaluation.",
                        points: [
                            "Python programming language"
                        ]
                    }
                ]
            }
        ]
    },
    "Mentor for PhD, MSc, and FYP": {
        details: [
            {
                title: "Mentor for PhD students",
                mentorship: [
                    {
                        name: "Du Zhenyuan",
                        project: "Cyber-Resilient Predictive Smart Energy Management for Microgrids and Nanogrids"
                    },
                    {
                        name: "Chen Hongyi",
                        project: "Probabilistic Electric Vehicle Charging Behavior Scenarios Modeling Considering Social Incentives with Large Language Model"
                    }
                ]
            },
            {
                title: "Mentor for MSc projects",
                mentorship: [
                    {
                        name: "Wang Bingyu",
                        project: "Multi-Agent Deep Reinforcement Learning Based Multi-Timescale Voltage Control For Distribution System",
                        year: "2022 Graduated"
                    },
                    {
                        name: "Du Zhenyuan",
                        project: "A Probabilistic Forecasting Method for Residential Load Demand based on Statistic Error Analysis",
                        year: "2021 Graduated"
                    },
                    {
                        name: "Zhou Lixi",
                        project: "Impact Study of Electric Vehicles on Power Distribution Network",
                        year: "2020 Graduated"
                    },
                    {
                        name: "Ma Aoxiang",
                        project: "Smart Nanogrid Energy Management System based on Deep Reinforcement Learning",
                        year: "2023 Graduated"
                    },
                    {
                        name: "Cao Wenhai",
                        project: "Transactive energy management of a microgrid with distributed energy resources",
                        year: "2024 Graduated"
                    },
                    {
                        name: "Sun Xinghao",
                        project: "Smart Home Energy Management Based on Deep Reinforcement Learning Technology",
                        year: "2024 Graduated"
                    },
                    {
                        name: "Zhang Xijia",
                        project: "Advanced User-level Load Forecasting based on Attention Mechanism and Deep Learning",
                        year: "2024 Graduated"
                    },
                    {
                        name: "Jiang Jinqi",
                        project: "Event-driven Load Forecasting with Large Language Models",
                        year: "2025 to be Graduated"
                    },
                    {
                        name: "Zhao Kaiwen",
                        project: "Load Forecasting in Distribution Network with Large Language Models and Retrieval-Augmented Generations",
                        year: "2025 to be Graduated"
                    }
                ]
            },
            {
                title: "Mentor for Undergraduate FYPs",
                mentorship: [
                    {
                        name: "Lin Rizhong James",
                        project: "Electricity load forecasting for smart home"
                    },
                    {
                        name: "Li Kexing",
                        project: "Smart home data analytics using AI tech"
                    },
                    {
                        name: "Ainiwaerjiang Subi",
                        project: "Electric vehicle charging modeling and forecasting"
                    },
                    {
                        name: "Niu Zhengyi",
                        project: "Solar PV power forecasting using AI tech"
                    },
                    {
                        name: "Goh Wei Zhang, Benedict",
                        project: "Smart Meter data analytics and power forecasting"
                    },
                    {
                        name: "Nikki Koh Wen",
                        project: "Smart home data collection and analysis"
                    }
                ]
            }
        ]
    }
};
export const academicActivities = {
    "Academic Services": [
        {
            content: "Editorial Roles",
            details: [
                "IEEE Singapore Chapter Committee Member.",
                "Topic Editor for MDPI special issue on Advanced Operation, Control, and Planning of Intelligent Energy Systems.",
                "Guest Editor for Frontiers in Energy Research.",
                "Guest Editor for IET Renewable Power Generation (in process).",
            ]
        },
        {
            content: "Reviewer",
            details: [
                "Outstanding Reviewer for IEEE Transactions on Power Systems.",
                "Reviewer for IEEE Transactions on Power Systems (>60 articles), IEEE Transactions on Smart Grid, IEEE Power Engineering Letters, IEEE Transactions on Sustainable Energy, and more."
            ]
        }
    ],
    "Academic Presentations": [
        {
            content: "Invited Talks and Presentations",
            details: [
                "Nanyang Business School, Short Course on Mastering ChatGPT for Academic Edge, 2024.",
                "Chongqing University Invited Speech on Data-driven Operation and Control for Power Systems, 2022.",
                "7th International Conference on New Energy and Future Energy Systems (NEFES 2022).",
                "NewRIIS Conference 2021.",
                "IEEE WCCI L2RPN Competition Solution Presentation."
            ]
        }
    ],
    "Undergraduate Competitions": [
        {
            content: "Mathematical Modeling",
            details: [
                "Meritorious Winner of Mathematical Contest in Modeling of U.S., COMAP, Apr. 2016.",
                "First Prize of Higher Mathematics Olympiads of China, Nov. 2014.",
                "Second Prize of Mechanical Innovation Design Competition of China, Jun. 2016."
            ]
        }
    ]
};



export const awardsAndCompetitions = {
  title: "Awards and Competitions",
  categories:
    [
      {
        content: "Awards",
        details: [
          "IEEE Transactions on Power Systems, Outstanding Reviewer.",
          "China Scholarship Council, Chinese Government Award for Outstanding Self-financed Students Abroad (Awarded by Embassy of the People's Republic of China in the Republic of Singapore), 2022.",
          "The 8th China International College Students ‘Internet+’ Innovation and Entrepreneurship Competition, International Track, Silver Award, 2022. Project on Digital Energy."
        ]
      },
      {
        content: "High-Impacts Competitions",
        details: [
          "The IEEE World Congress on Computational Intelligence (Deep reinforcement learning), Learning to Run a Power Network WCCI competition 2020: ranked 3rd globally, 2020. Sponsored by France RTE electric company (Réseau de Transport d'Électricité), GEIRI North America, State Grid Jiangsu electric power company, ChaLearn.",
          "The NeurIPS competitions (Deep reinforcement learning), L2RPN NEURIPS 2020, ranked 7th for robustness track, 2020. Sponsored by France RTE electric company, Electric Power Research Institute, ChaLearn, Google Research, UCL, IQT Labs.",
          "The NeurIPS competitions (Deep reinforcement learning), L2RPN NEURIPS 2020, ranked 7th for robustness track, ranked 9th for adaptability track, 2020. Sponsored by France RTE electric company, Electric Power Research Institute, ChaLearn, Google Research, UCL, IQT Labs.",
          "Meritorious Winner of Mathematical Contest in Modeling of U.S., COMAP, Apr. 2016. Sponsored by the Consortium for Mathematics and Its Application of America."
        ]
      },
    ]
};

export const softwareDevelopment = {
  title: "Software Development",
  categories: [
    {
      content: "Software Systems",
      details: [
        "(Local Executables) Electric Vehicle Impact Analysis and Urban Living Electrical Infrastructure Planning Software System (Housing& Development Board Project, Singapore).",
        "(Web App, Full-stack with Backend and Frontend) Advanced Energy Management and Data-Fusion Software System for Microgrid System (LITE-ON Project, Singapore), Advanced Energy Management and Data-Fusion Software System for Nanogrid System (LITE-ON Project, Singapore).",
        "(Web App, Co-development, Backend) Risk-based Asset Management Optimization System (SP Group, Singapore)"
      ]
    },
    {
      content: "Code Packages",
      details: [
        "Data-driven power systems real-time operation code packages (the DRL algorithms includes DDPG, DQN, A3C, PPO, SAC, Rainbow, PD-DDPG, multi-agent DRL, etc.; the power system modeling includes power flow equations, Newton-Ralfsnn's method, optimal power flows formulations, probabilistic power flow, power grid visualization, etc.).",
        "Data-driven power systems control code packages (including multiple state-of-art DRL algorithms and power systems dynamic modelling).",
        "Time-series Monte Carlo Simulation code packages.",
        "Competitions-related code packages.",
        "Probabilistic forecasting code packages."
      ]
    },
  ]
};

export const industrialAndResearchContributions = [
    {
        period: "12/2021-Now",
        institution: "Nanyang Technological University, Singapore",
        contributions: [
            {
                project: "SP Group",
                tasks: [
                    "Development of methodologies for risk optimization, criticality analysis, and health analysis for assets.",
                    "Geospatial Characterization of Asset Risk Distribution in Singapore.",
                    "Developed geospatial risk distribution analysis model for transformers, switchgear, cables, and RMUs on Singapore's geospatial map.",
                    "Asset Risk Optimization and Forecasting Considering Asset Health and Criticality.",
                    "Generated a solution for asset investment saving, saving over S$700 million between 2024 to 2035.",
                    "Statistical Projection of Scenarios for SP Assets Planning Strategies (Transformers, Cables, Switchgear).",
                    "Asset Replacement Planning Optimization based on Cost-Effectiveness Prioritization.",
                    "Asset Health Index integrating Conditional Probability and Weibull Model.",
                    "Backend software development for risk valuation and planning optimization."
                ]
            },
            {
                project: "LITEON: Advanced Energy Management and Data fusion for Smart Microgrids and Smart Nanogrids",
                tasks: [
                    "Developed and implemented smart energy management systems for microgrids using deep reinforcement learning and optimization techniques.",
                    "Automated probabilistic forecasting for energy market with API integration.",
                    "Full-Stack Web App Development for energy management system."
                ]
            },
            {
                project: "National Environment Agency (NEA)",
                tasks: [
                    "Developed temporal-geospatial visualization of residential, industrial, and commercial loads for climate change impact analysis.",
                    "Co-authored research proposals securing funding from NEA and EMA."
                ]
            },
            {
                project: "ComfortDelGro: Singapore Electric Vehicle Charging Infrastructure Planning",
                tasks: [
                    "Developed EV infrastructure planning models using LTA API, focusing on probabilistic EV charging demand and optimal location bidding for 2025 to 2035."
                ]
            }
        ]
    },
    {
        period: "10/2018-12/2021",
        institution: "Nanyang Technological University, Singapore",
        contributions: [
            {
                project: "Degree Research: Data-driven Operation and Control for Power Systems",
                tasks: [
                    "Developed methodologies combining deep reinforcement learning and power system physical models.",
                    "Published 8 papers in this area and participated in IEEE and NeurIPS competitions.",
                    "Solutions for China Southern Power Grid Company including YOLO-V5 based substation security monitoring."
                ]
            },
            {
                project: "Housing & Development Board (NRF project)",
                tasks: [
                    "Developed probabilistic load forecasting models for EV behaviors in urban residential areas."
                ]
            },
        ]
    },
    {
        period: "10/2016-12/2017",
        institution: "Lab of Dr. Wenyuan Li, Chongqing University, China",
        contributions: [
            {
                project: "National Natural Science Fund of China",
                tasks: [
                    "Developed fast computation algorithms combining deep learning and power system analysis for integrated energy systems."
                ]
            },
            {
                project: "Sichuan Province Grid Reliability",
                tasks: [
                    "Developed code for fast probabilistic power flow analysis for large-scale grids."
                ]
            }
        ]
    }
];


export const network = {
    title: 'Network',
    content: `
    • Demonstratable networks with SP Group, LITEON, A*STAR, ComfortDelGro, HUAWEI, EDF, RTE, China Southern Power Grid Company, EMA, NEA, China International Engineering Consulting Corporation, Housing& Development Board, State Grid Sichuan Company of China, and others.
    • Connections with World-wide Universities and Institutions, including Tsinghua University, Sichuan University, Sydney University, Aalto University, Chongqing University, Colorado School of Mines, Cambridge University, and others.
    • Manage Community Group for over 651 persons including power & energy faculties, students, and engineers.
  `
}
